import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * 建物スタイル変更ダイアログ
 * 【表示タイミング】
 * 1）建物スタイルボタン押下
 * 2）建物スタイル未指定の場合は、３D遷移時に表示
 */
class BuildStyleMenu extends Dialog {
  /**
     * コンストラクタ
     */
  constructor(draggable: boolean) {
    super(draggable);

    // let id: string, title: string, contents: string, footer: string;

    // 情報をGET
    const data:any = marietta.webcad.WebCADGlobal.webcad2Dmanager.buildStyleListData;

    // ダイアログのコンテンツ生成
    let id = 'buildStyleDialog';
    // タイトル
    let title = 'Select a style';
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'jp': title = '建物スタイルを選択してください'; break;
      default: title = 'Select a style'; break;
    }

    const len: number = Object.keys(data).length;
    let contents:string = '<div class="dialogBuildStyleBox">\n';
    if (len < 4) {
      contents = `<div class="dialogBuildStyleBox" style="width:'${200 * len} px;">\n`;
      document.querySelectorAll('.dialogBuildStyleBox').forEach((element) => {
        // eslint-disable-next-line no-param-reassign
        (<HTMLElement>element).style.width = (200 * len).toString();
      });
    }
    for (let i = 0; i < Object.keys(data).length; i += 1) {
      contents += '<div class="buildStyleBtn">\n';
      contents += '<a href="javascript:void(0)">\n';
      contents += '<div class="buildStyleImage">\n';
      contents += `<img src="${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}buildStyle/${data[i].pic}" alt="">\n`;
      contents += '</div>\n';
      contents += '<div class="buildStyleTitle">\n';
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'jp': contents += data[i].namejp; break;
        default: contents += data[i].nameen; break;
      }
      contents += '</div>\n';
      contents += '</a>\n';
      contents += '</div>\n';
    }
    contents += '</div>';
    let footer = '';

    this.createDialog(id, title, contents, footer);

    this.viewObj.querySelectorAll('.buildStyleBtn').forEach((element) => {
      element.addEventListener('click', this.close);
    });

    // eslint-disable-next-line no-multi-assign
    id = title = contents = footer = null;
  }
}

export default BuildStyleMenu;
